<div class="enroll-card enroll-card--boxed">
    <div class="enroll-page-header text-center">
        <mat-icon class="enroll-hero-icon">task_alt</mat-icon>
        <h1>Enrollment Confirmed</h1>
        <p class="page-description">Thank you for enrolling.</p>
    </div>

    <div class="enroll-section-body">
        <div class="mb-6">
        <h2 class="enroll-subhead">Member Information</h2>
        <div class="bg-gray-50 rounded-lg p-4">
            <div class="flex justify-between mb-2 text-sm">
            <span class="text-gray-500">Name:</span>
            <span class="font-medium">{{member.firstName}} {{member.middleName}} {{member.lastName}}</span>
            </div>
            <div class="flex justify-between text-sm" [class.mb-2]="!!effectiveDate">
            <span class="text-gray-500">Email:</span>
            <span class="font-medium">{{ displayEmail }}</span>
            </div>
            <div class="flex justify-between text-sm" *ngIf="effectiveDate">
            <span class="text-gray-500">Effective date:</span>
            <span class="font-medium">{{effectiveDate}}</span>
            </div>
        </div>
        </div>

        <div class="mb-6">
        <h2 class="enroll-subhead">Your Subscription Plan<ng-template *ngIf="plans.length > 0">s</ng-template></h2>
        <div class="bg-gray-50 rounded-lg p-4 space-y-4">
            @for (plan of plans; track plan; let  i = $index) {
                <div [ngClass]="{ 'border-b border-gray-200 pb-4': i < plans.length - 1 }">
                    <div class="plan-row text-sm">
                    <span class="plan-name">{{plan.productName | titlecase}}</span>
                    <span class="plan-price">{{ planRate(plan) | currency }} {{ paymentFrequency() | lowercase }}</span>
                    </div>
                </div>
            }
        </div>
        </div>
    </div>
</div>
